import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { csvUrl, getData } from '../CustomUtils'
import ReportHeading from '../ReportHeading.js'
import ColumnHeadings from '../ColumnHeadings.js'
import { DUPLICATE_PLAINTIFF_REPORT_QUERY } from '../../../graphql.js'
import ReportGrid from '../ReportGrid'
import ParameterValues from '../ParameterValues.js'
import '../Custom.css'
import LargeRowHandler from '../LargeRowHandler.js'

const DUPLICATE_PLAINTIFF_REPORT = gql(DUPLICATE_PLAINTIFF_REPORT_QUERY)

export default function DuplicatePlaintiffReport({ location }) {
  console.log('DuplicatePlaintiffReport rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, DUPLICATE_PLAINTIFF_REPORT, 'duplicatePlaintiffReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    console.log(results)
    const viewButtonIndex = 16
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('BosSci/duplicatePlaintiffReport/duplicate_plaintiff_report', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white', width: 'auto', minWidth: '800px', margin: 'auto'}} >
          <ReportHeading title={'Duplicate Plaintiffs'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} viewButtonDataIndex={viewButtonIndex} location={location} />
          </tbody>
        </Table>
      </div>
    )
  }
}